



<div class="ui-loader-spinner">
    <!-- <p-progressSpinner [class.eds-small]="true"></p-progressSpinner>
    <div class="loadingio-spinner-rolling-lrznwydorh">
        <div class="ldio-zg1b405h63l">
            <div></div>
        </div>
    </div>-->
    <img src="./assets/images/spinner.gif" alt="spinner" class="spinner-img" /> 
    <h5>רק רגע...</h5>
    <h6>{{text}}</h6>
</div>